// I need to create a form and a flow to make it easy to add new entry. So here I will add hard coded data for a start.
// This data will be used to populate the form fields when creating a new entry and then calculate the final entry object to be sent to the backend.

export const entryCreateData = {
  level: [
    {
      label: "BSA (National)",
      id: 1,
      category_types: [
        { label: "Open", id: 1, event_types: [3, 2, 9, 10], tier: 2 },
        { label: "Veteran", id: 2, event_types: [3, 2, 9], tier: 2 },
        { label: "Junior", id: 3, event_types: [3, 9], tier: 2 },
        { label: "B-Team", id: 5, event_types: [9], tier: 6 },
      ],
      availablePositions: [1, 2, 3, 4, 5, 6, 10],
    },
    {
      label: "PBA (National)",
      id: 2,
      category_types: [
        { label: "Other", id: 4, event_types: [1, 11], tier: 1 },
      ],
      availablePositions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    },
    {
      label: "Provincial",
      id: 3,
      category_types: [
        { label: "Open", id: 1, event_types: [8], tier: 7 },
        { label: "Veteran", id: 2, event_types: [8], tier: 7 },
        { label: "Junior", id: 3, event_types: [8], tier: 7 },
      ],
      availablePositions: [1, 2, 3, 5, 6, 10],
    },
    {
      label: "District",
      id: 4,
      category_types: [
        { label: "Open", id: 1, event_types: [4, 5], tier: 3 },
        { label: "Veteran", id: 2, event_types: [4, 5], tier: 3 },
        { label: "Junior", id: 3, event_types: [4, 5], tier: 3 },
      ],
      availablePositions: [1, 2, 3, 5, 6, 10],
    },
    {
      label: "Club",
      id: 5,
      category_types: [
        { label: "Other", id: 4, event_types: [7, 6, 12, 13], tier: 8 },
      ],
      availablePositions: [1, 2, 3, 4, 10],
    },
  ],
};

export const eventTypes = [
  { label: "BSA Masters", id: 3, formats: [1], tier: 2 },
  { label: "SA Open", id: 2, formats: [1, 2, 4], tier: 2 },
  { label: "Inter-Districts", id: 9, formats: [9, 6], tier: 6 },
  { label: "Mixed Pairs", id: 10, formats: [2], tier: 6 },
  { label: "PBA Qualifier", id: 11, formats: [1, 2], tier: 7 },
  { label: "PBA World - Cape Town", id: 1, formats: [1, 2] },
  { label: "Provincial", id: 8, formats: [1, 2, 3, 4, 10] },
  { label: "District", id: 4, formats: [1, 2, 3, 4, 8, 10, 12] },
  { label: "District Masters", id: 5, formats: [1] },
  {
    label: "Fairtree Tournament",
    id: 13,
    formats: [1, 2, 3, 4, 10, 12],
    tier: 8,
  },
  { label: "Fairtree Classic", id: 12, formats: [1, 2, 3, 4, 10, 12], tier: 8 },
  { label: "1/2 Green Classic", id: 7, formats: [1, 2, 3, 4, 10, 12], tier: 5 },
  { label: "3/4 Green Classic", id: 6, formats: [1, 2, 3, 4, 10, 12], tier: 4 },
];

export const eventFormats = [
  { label: "Singles", id: 1 },
  { label: "Pairs", id: 2, exclude_in_category_type: [2, 3] },
  { label: "Trips", id: 3 },
  { label: "Fours", id: 4, exclude_in_category_type: [3] },
  {
    label: "Inter-Districts",
    id: 6,
    format_id: 9,
  },
  { label: "Champ of Champions", id: 8 },
  { label: "U15, U18, U20, U35", id: 7 },
  { label: "Fives", id: 10 },
  { label: "Masters", id: 11 },
  { label: "Mixed Pairs", id: 12 },
];

// Age groups for junior categories, this is just for a dropdown but will link to eventFormat with id 7
export const juniorsAgeGroups = [
  { label: "U15", id: 1, max_age: 15 },
  { label: "U18", id: 2, max_age: 18 },
  { label: "U20", id: 3, max_age: 20 },
  { label: "U35", id: 4, max_age: 35 },
];
